import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=6c0bb7c5&scoped=true"
import script from "./Fab.vue?vue&type=script&lang=js"
export * from "./Fab.vue?vue&type=script&lang=js"
import style0 from "./Fab.vue?vue&type=style&index=0&id=6c0bb7c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0bb7c5",
  null
  
)

export default component.exports